/**
 * Regarde si le burger est visible pour déterminer si on est en mobile ou non
 * @returns {boolean}
 */
const is_mobile = () => {
    return $('#burger-menu').is(':visible');
}


export default is_mobile;